import { Component, inject, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { CommonService } from '../../../services/common.service';
import { FormControl, Validators } from '@angular/forms';
import { isPlatformBrowser } from '@angular/common';
import { PanelGuId, PanelId } from '../../../model/constants/AppConstants';
import { userApi } from '../../../model/constants/endpoints';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-complete-join-profile-component',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './complete-join-profile.component.html'
})
export class CompleteJoinProfileComponent implements OnInit, OnDestroy {
  readonly dialog = inject(MatDialog);
  updateJoinForm: any;
  countryLanguage: any;
  signUpArray = [];
  countryId: number;
  languageId: number;
  trafficId: string;
  language: string;
  affilateid: any;
  transid: any;
  campid: any;
  affiliateTrafficId: string;
  statusCodeMap = require('../../../../core/model/constants/SCMapping.json');
  gender: any;
  hearAboutQuestion: any;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private commonService: CommonService, // Assuming CustomService is defined and imported correctly
  ) { }

  // Additional methods and properties can be added here as needed
  ngOnInit() {
    this.getCountryLanguage();
    this.updateJoinProfileForm();
  }

  ngOnDestroy() {
    // Cleanup logic can go here if needed
  }


  updateJoinProfileForm() {
    this.updateJoinForm = this.commonService.fb.group({
      gender: new FormControl('', [Validators.required]),
      zipCode: new FormControl('', [Validators.required]),
      language: new FormControl('', [Validators.required]),
      dob: new FormControl('', [Validators.required]),
      opinionEdgeHear: new FormControl('', [Validators.required]),
      acceptTerms: new FormControl(false),
    })
  }

  getCountryLanguage() {
    this.commonService.spinner.show();
    const affiliateUrl = isPlatformBrowser(this.platformId) ? location.origin + `/#/join?affid=${this.affilateid}&tid=${this.transid}&campid=${this.campid}&scampid=${this.campid}` : ''
    //Method for  Get CountryLanguage
    const body = {
      panelId: PanelId.OpinionEdge,
      panelGuid: PanelGuId.OpinionEdge,
      affId: this.affilateid,
      tId: this.transid,
      campId: this.campid,
      subCampId: this.campid,
      device: 3,
      affiliateUrl,
    }
    this.commonService.httpApiService.post(userApi.getCountryLanguage, body).then((res: any) => {
      this.countryLanguage = res.data ? res.data : [res];
      this.getCountryDetails(this.countryLanguage[0]);
    }).catch((error: any) => {
      this.handleErrorResponse(error);
    })
  }

  getCountryDetails(countryLanguage?: any) {
    this.countryId = countryLanguage?.countryId;
    this.languageId = countryLanguage?.languageId;
    this.language = countryLanguage?.countryLanguage;
    this.trafficId = countryLanguage?.trafficId;
    this.affiliateTrafficId = countryLanguage?.affiliateTrafficId;
    this.getSignUpQuestion(this.countryLanguage, this.trafficId);
  }

  async getSignUpQuestion(country, trafficId) {

    const countryDetails = country[0];
    const bodyRequest = {
      option: [
        {
          countryId: countryDetails.countryId,
          languageId: countryDetails.languageId,
          language: countryDetails.countryLanguage,
          isSelected: true,
        },
      ],
      panelGuid: PanelGuId.OpinionEdge,
      countryId: countryDetails.countryId,
      trafficId
    }
    try {
      const response: any = await this.commonService.httpApiService.post(userApi.getSignupQsnViaLanguage, bodyRequest);
      this.setSignupQuestionArray(response);
    } catch (error) {
      this.handleErrorResponse(error);
    }
  }

  onLanguageSelect(event) {
    const value = event.target.value
    const countryId = this.countryLanguage.find(item => item.countryLanguage === value)
    this.countryId = countryId.countryId
    this.languageId = countryId.languageId
    this.affiliateTrafficId = countryId.affiliateTrafficId;
  }

  handleErrorResponse(err: any) {
    this.commonService.spinner.hide();
    if (!err.statusCode) {
      this.commonService.translate.get('somethingWentWrong').subscribe((res: string) => {
        this.commonService.userService.showError(res)});
      return;
    }
    const mappedStatusCode = this.statusCodeMap[0][err.statusCode];
    if (err.statusCode == '1012') {

      this.commonService.userService.showError('1012')
      return;
    }
    this.commonService.userService.showError(mappedStatusCode)
  }

  public isFieldInvalid(fieldName: string): boolean {
    const control = this.updateJoinForm?.get(fieldName);
    return !!(control && control.invalid && (control.touched || control.dirty));
  }

  signupAnswers() {
    const joinFormValues = this.updateJoinForm.value;
    const { zipCode, gender, opinionEdgeHear } = joinFormValues;

    this.signUpArray.forEach((element: any) => {
      const { qsnShortForm, option } = element;

      // Handle specific cases with a map for quicker lookup
      const handlers: Record<string, () => void> = {
        'Zip': () => {
          element.answerKey = zipCode?.replace(/\s/g, '')?.toUpperCase();
        },
        'DOB': () => {
          element.answerKey = this.getFormattedDate();
        },
        'GENDER': () => {
          element.answerKey = gender;
          option.forEach((genderKey: any) => {
            genderKey.isSelected = genderKey.optionStatement === gender;
          });
        },
        'STANDARD_Opinion Edge': () => {
          element.answerKey = opinionEdgeHear;
          option.forEach((opinionHear: any) => {
            opinionHear.isSelected = opinionHear.optionStatement === opinionEdgeHear;
          });
        },
      };

      if (handlers[qsnShortForm]) {
        handlers[qsnShortForm]();
      }

    });

  }

  getFormattedDate(): string {
    const rawDate = this.updateJoinForm.get('dob')?.value;

    if (!rawDate) return '';

    const date = new Date(rawDate); // Convert string to Date
    if (isNaN(date.getTime())) return ''; // Invalid date check

    const day = this.padZero(date.getDate());
    const month = this.padZero(date.getMonth() + 1);
    const year = date.getFullYear();
    return `${month}/${day}/${year}`; // MM/DD/YYYY
  }

  private padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

  updateJoinRequestBody() {
    const requestBody: any = {
      countryId: this.countryId,
      languageId: this.languageId,
      referral: this.commonService.storageService.getSessionItem('referralCode'),
      affiliateTrafficId: this.affiliateTrafficId || null,
      signupQsn: this.signUpArray,
      panelistId: this.commonService.storageService.getItem('panelistId')
    };
    if (!requestBody.visitorId) delete requestBody.visitorId;
    return requestBody;
  }

  onSubmitData() {
    this.signupAnswers();
    if (this.validateForm()) {
      const body = this.updateJoinRequestBody();
      this.createUserAccount(body);
    }
  }

  validateForm() {
    if (this.updateJoinForm.get('acceptTerms').invalid) {
      this.commonService.translate.get('pleaseAccept').subscribe((res: string) => {
        this.commonService.userService.showError(res)});
      return false;
    }
    return true;
  }

  createUserAccount(body) {
    this.commonService.httpApiService.post(userApi.updateJoinDetails, body).then((res: any) => {
      this.handleUserCreationSuccess(res);
    }).catch((err) => {
      this.handleErrorResponse(err);
    });
  }

  handleUserCreationSuccess(res: any) {
    const userRes = res;
    this.commonService.translate.get('userCreate').subscribe((res: string) => {
      this.commonService.userService.showError(res)});
    this.commonService.storageService.handleUpdateGoogleJoinData(userRes);
    this.commonService.router.navigate(['/dashboard']);
    this.dialog.closeAll();
    window.scrollTo(0, 0);
  }

  setSignupQuestionArray(qsns) {
    this.commonService.spinner.hide();
    this.signUpArray = qsns.signupQsn;
    this.gender = qsns?.signupQsn?.find((qsn: any) => qsn.qsnShortForm === 'GENDER');
    this.hearAboutQuestion = qsns?.signupQsn?.find((qsn: any) => qsn.qsnShortForm === 'STANDARD_Opinion Edge')
  }

}
